import React, { useEffect } from 'react'
import { Form, Field } from 'redux-form'
import moment from 'moment'

import LoadingLinear from 'components/Loading/LoadingLinear'
import Input from 'components/Input/Input/Input'
import Button from 'components/Button'

import s from './ConfirmationCodeForm.scss'

export default props => {
  const {
    type, // 'email' or 'tel'
    sendOnShow, // do we need to send create request when form is shown (meta.dirty || !confirmation.isSent)
    recipient, // email or phone (either entered value or confirmation.value)
    confirmation, // confirmation token
    loading, // true if confirmation token is creating right now
    verifying, // true if code is verifying right now
    delay,
    usernameIsChanging,
    disableSubmit,

    handleSubmit,
    createEmailConfirmation,
    confirmEmailWithCode,
    createPhoneConfirmation,
    confirmPhoneWithCode,
  } = props

  useEffect(() => {
    if (sendOnShow) {
      if (type === 'email') {
        createEmailConfirmation(recipient)
      }

      if (type === 'tel') {
        createPhoneConfirmation(recipient)
      }
    }
  }, [])

  const verify = ({ code }) => {
    if (type === 'email') {
      confirmEmailWithCode(code)
    }

    if (type === 'tel') {
      confirmPhoneWithCode(code)
    }
  }

  const repeat = () => {
    if (type === 'email') {
      createEmailConfirmation(recipient)
    }

    if (type === 'tel') {
      createPhoneConfirmation(recipient)
    }
  }

  if (verifying) {
    return (
      <div>
        Verifying confirmation code...
        <br />
        <br />
        <LoadingLinear />
      </div>
    )
  }

  if (loading) {
    return (
      <div>
        Sending confirmation code...
        <br />
        <br />
        <LoadingLinear />
      </div>
    )
  }

  const sendAgainText = delay.active
    ? `Send again in ${moment.utc(delay.seconds * 1000).format('mm:ss')}`
    : 'Send again'

  return (
    <Form onSubmit={handleSubmit(verify)}>
      {confirmation && confirmation.isSent && (
        <div className={s.info}>
          {type === 'email' ? 'Email' : 'SMS'} with confirmation code has been sent to{' '}
          <b>{confirmation.value}</b> {moment(confirmation.sentAt).fromNow()}
        </div>
      )}

      {usernameIsChanging && (
        <div className={s.info}>
          <h3>Warning!</h3>
          <p>
            <b>{recipient}</b> should be used for signing in after confirmation.
          </p>
        </div>
      )}

      <Field
        name="code"
        label="Confirmation Code"
        component={Input}
        info="Enter confirmation code you have received"
      />

      <Button
        color="google"
        size="sm"
        type="submit"
        style={{ marginRight: '3rem' }}
        disabled={disableSubmit}
      >
        Verify
      </Button>

      <Button
        color={delay.active ? 'standard' : 'facebook'}
        size="sm"
        onClick={repeat}
        disabled={delay.active}
      >
        {sendAgainText}
      </Button>
    </Form>
  )
}



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Auth/ConfirmationCodeForm/ConfirmationCodeForm.jsx